<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  qualityAlert,
  categoryChange,
  pendingCategory,
} from './templateStatus';

const props = defineProps({
  template: { type: Object, required: true },
});

const { t } = useI18n();

const categoryName = category =>
  t(`WHATSAPP_TEMPLATES.MANAGER.CATEGORY.${category}`);

const alerts = computed(() => {
  const list = [];
  const quality = qualityAlert(props.template);
  if (quality) {
    list.push({
      key: 'quality',
      tone: quality === 'RED' ? 'text-n-ruby-11' : 'text-n-amber-11',
      text: t(`WHATSAPP_TEMPLATES.MANAGER.ALERT.QUALITY_${quality}`),
    });
  }
  const change = categoryChange(props.template);
  if (change) {
    list.push({
      key: 'changed',
      tone: change.costlier ? 'text-n-ruby-11' : 'text-n-slate-11',
      text: t(
        `WHATSAPP_TEMPLATES.MANAGER.ALERT.${change.costlier ? 'CATEGORY_COSTLIER' : 'CATEGORY_CHANGED'}`,
        { from: categoryName(change.from), to: categoryName(change.to) }
      ),
    });
  }
  const pending = pendingCategory(props.template);
  if (pending) {
    const date = pending.effectiveAt
      ? t('WHATSAPP_TEMPLATES.MANAGER.ALERT.CATEGORY_PENDING_DATE', {
          date: new Date(pending.effectiveAt).toLocaleDateString(),
        })
      : '';
    list.push({
      key: 'pending',
      tone: 'text-n-amber-11',
      text: t('WHATSAPP_TEMPLATES.MANAGER.ALERT.CATEGORY_PENDING', {
        category: categoryName(pending.category),
        date,
      }),
    });
  }
  return list;
});
</script>

<template>
  <ul v-if="alerts.length" class="m-0 flex list-none flex-col gap-0.5 p-0">
    <li
      v-for="alert in alerts"
      :key="alert.key"
      class="text-xs"
      :class="alert.tone"
    >
      {{ alert.text }}
    </li>
  </ul>
</template>
